import React, { useState } from 'react';

import utils from '../../../services/utils';
import ShowArrowButton from '../../Buttons/ShowArrowButton/ShowArrowButton';
import SupplierAndInvoiceCard from '../../Cards/SupplierAndInvoiceCard/SupplierAndInvoiceCard';
import ResultOrigin from '../ResultOrigin/ResultOrigin';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';

import classes from './PurchasesResult.module.scss';

const PurchasesResult = ({ payPurchasesData, view, showDetails, showInvoiceDetail, methodForPay, costTransaction }) => {
  const [isShowState, setIsShowState] = useState(true);

  const setShowHandler = () => {
    setIsShowState(show => !show);
  };

  return (
    <>
      <ResultOrigin
        methodForPay={methodForPay}
        datePay={payPurchasesData.date}
        origin={
          methodForPay === 'PSEPay'
            ? (payPurchasesData.psePayins || []).map(origin => ({
                bankAccount: {
                  bankId: 'PSE',
                  name: origin.name,
                  endUser: {
                    identificationTypeLabel: documentTypesAbbreviationsObject[origin.identificationType],
                    identificationNumber: origin.identificationNumber
                  }
                }
              }))
            : (payPurchasesData.druoPayments || []).map(origin => ({
                value: origin.withdrawedValue,
                bankAccount: {
                  bankId: origin.sourceBankDruoId,
                  subtypeLabel: origin.sourceBankAccountTypeLabel,
                  bankLast4Digits: origin.sourceBankAccountNumber,
                  name: origin.sourceBankOwnerName,
                  endUser: {
                    identificationTypeLabel: origin.sourceBankOwnerIdentificationTypeLabel,
                    identificationNumber: origin.sourceBankOwnerIdentificationNumber
                  }
                }
              }))
        }
      />

      <div className={classes.suppliers}>
        <span className={`medium-12 ${classes['title-suppliers']}`}>PROVEEDORES</span>
        <div className={classes['card-suppliers']}>
          {(payPurchasesData.payouts || []).map(
            ({
              receiverName,
              receiverLastName,
              receiverBusinessName,
              receiverPersonTypeId,
              payedValue,
              bankId,
              metadata,
              bankAccountOwnerName,
              bankAccountOwnerLastName,
              bankAccountOwnerBusinessName,
              bankAccountOwnerPersonTypeId,
              bankAccountType,
              supplierId,
              meloStatus,
              bankAccountOwnerIdentificationType,
              bankAccountOwnerIdentificationNumber,
              statusDescription,
              bankAccountNumber,

              bankIdMovii
            }) => {
              // Validar que metadata existe antes de acceder a purchases
              const purchases = metadata?.purchases || [];
              
              return (
                <SupplierAndInvoiceCard
                  bankAccountType={bankAccountType}
                  supplierMoviiBankId={bankIdMovii}
                  methodForPay={methodForPay}
                  key={supplierId}
                  supplierId={supplierId}
                  payoutId={payPurchasesData.payoutId}
                  view={view}
                  meloStatus={meloStatus}
                  statusDescription={statusDescription}
                  supplierName={receiverPersonTypeId === '2' ? `${receiverName} ${receiverLastName}` : receiverBusinessName}
                  bankId={bankId}
                  bankLast4Digits={utils.getLast4Digit(bankAccountNumber)}
                  purchasesItems={purchases}
                  totalValue={payedValue}
                  owner={
                    bankAccountOwnerPersonTypeId === '2'
                      ? `${bankAccountOwnerName} ${bankAccountOwnerLastName}`
                      : bankAccountOwnerBusinessName
                  }
                  identification={`${documentTypesAbbreviationsObject[bankAccountOwnerIdentificationType]} ${bankAccountOwnerIdentificationNumber}`}
                  showDetails={showDetails}
                  showInvoiceDetail={showInvoiceDetail}
                />
              );
            }
          )}
        </div>
      </div>

      <div className={classes['div-details']}>
        <div className={classes['button-details']}>
          <span className='medium-16'>
            {payPurchasesData.totalPurchases} cuenta de cobro de {payPurchasesData.totalSuppliers} proveedor
          </span>

          <ShowArrowButton onClick={setShowHandler} showState={isShowState} />
        </div>
        {costTransaction && payPurchasesData.totalSuppliers && (
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span className='medium-14'>Fees de transacción:</span>
            <span className='medium-14'>
              <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
                {utils.moneyFormat(costTransaction * payPurchasesData.totalSuppliers)}
              </span>
            </span>
          </div>
        )}
        <div className={classes.total}>
          <span className='semibold-20'>TOTAL</span>
          <span className='semibold-20'>{utils.moneyFormat(payPurchasesData.totalValue)}</span>
        </div>
        {costTransaction && payPurchasesData.totalSuppliers && (
          <span className='medium-12' style={{ color: 'var(--blue-night-2)', marginTop: '8px', display: 'block' }}>
            *Fees de transacción: <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>{utils.moneyFormat(costTransaction * payPurchasesData.totalSuppliers)}</span> (Descuento especial)
          </span>
        )}
        {isShowState && (
          <div className={classes.details}>
            {/*  <span>Detalle A - 20.000</span>
              <span>Detalle B - 30.000</span>
              <span>Detalle C - 50.000</span> */}
          </div>
        )}
      </div>
    </>
  );
};

export default PurchasesResult;
